// Alert notification on th app.
const NotificationMixin = {
  data() {
    return {
      notification: {
        show: false,
        message: null,
        variant: 'danger'
      }
    }
  },

  methods: {
    showSuccessNotification(message) {
      this.setNotification({show: true, message, variant: 'success'});
    },

    showErrorNotification(message) {
      this.setNotification({show: true, message, variant: 'danger'});
    },

    setNotification(object) {
      // Scroll certain amounts from current position
      window.scrollTo({
        top: 0, // could be negative value
        left: 0,
        behavior: 'smooth'
      });

      this.notification = {...this.notification, ...object};
    },

    resetNotification() {
      this.setNotification({
        message: null,
        show: false
      })
    }
  }
};

export default NotificationMixin;



// WEBPACK FOOTER //
// ./src/mixins/notification.js